import { gql } from '@apollo/client';

const GET_MASTERCODE_ACTIVATION_DETAILS = gql`
  query getMastercodeActivationDetails(
    $where: MastercodesWhereInput!
    $expirationWhere: OrderItemDateExpirationInput!
  ) {
    mastercodes(where: $where) {
      id
      code
      orderItems {
        dateExpiration(where: $expirationWhere)
      }
    }
  }
`;

export default GET_MASTERCODE_ACTIVATION_DETAILS;
